// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ZoomContainer_displayZoomImage":"SZF9p","ZoomContainer_button":"rxmLS","ZoomContainer_close":"ZQiIs","ZoomInCursorImage":"uB3TA","ZoomOutCursorImage":"ROVOV"};